import { render, staticRenderFns } from "./addToCartIcon.vue?vue&type=template&id=08f45f8c&scoped=true&"
import script from "./addToCartIcon.vue?vue&type=script&lang=js&"
export * from "./addToCartIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f45f8c",
  null
  
)

export default component.exports